import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PupilLinkState } from './pupil-link.state';

export const selectPupilLinkState = createFeatureSelector<PupilLinkState>('pupilLink');

export const selectPupilLinkMismatches = createSelector(
  selectPupilLinkState,
  (state) => state.mismatches
);

export const selectPupilLinkLoading = createSelector(
  selectPupilLinkState,
  (state) => state.loading
);

export const selectPupilLinkError = createSelector(
  selectPupilLinkState,
  (state) => state.error
);

export const selectPupilLinkActionInProgressId = createSelector(
  selectPupilLinkState,
  (state) => state.actionInProgressId
);
